module.exports = {
          srcSet: __webpack_public_path__ + "13b51c53da7e30b780ad3a43594a9b38-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "13b51c53da7e30b780ad3a43594a9b38-1168.png",width: 1168,height: 198}],
          src: __webpack_public_path__ + "13b51c53da7e30b780ad3a43594a9b38-1168.png",
          toString:function(){return __webpack_public_path__ + "13b51c53da7e30b780ad3a43594a9b38-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACMiJv04ODz/ODk9/kFCR/85OD3/FB4n/4E6Lv90KiT+R0I3/049MfsAGBgd9iYlKv8kJCr+Kywx/y0tMv8WHyf/cDMn/3YyLv6yjlP/sIoz8xv1Ic/4kIZoAAAAAElFTkSuQmCC",
          width: 1168,
          height: 198
        }